import { Box, useMediaQuery, IconButton } from "@mui/material";
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Tooltip as MuiTooltip } from "@mui/material";
import { AppsVisibilityType, workflowItem } from "../../../Types/Workflow-Types";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import EditPinWithBackgroundIcon from "../../../Custom-imeges/Workflows-Icons/EditPinIcon";
import ReplaceIcon from "../../../Custom-imeges/Workflows-Icons/ReplaceIcon";
import DeleteIcon from "../../../Custom-imeges/Workflows-Icons/DeleteIcon";
import { setAllWorkflows, setVideoAppSettings, SuitesAppTypes } from "../../../store/one-query/workflowsSlice";
import {
  ImageSuiteApps,
  SummarizeOutputValues,
  TextSuiteApps,
  WorkflowAppInputAndOutputTypes,
  WorkflowAppType,
} from "../../../Helper";
import { useNavigate, useParams } from "react-router-dom";
import { getAppDetails, GetAppType } from "../../../Helpers/WorkflowHelper";
import {
  setFileError,
  setSnackBarAlert,
} from "../../../store/one-query/chatsSlice";
import {
  useCreateWorkflow,
  useGetAllWorkFlows,
  useupadteWorkflow,
} from "../../../store/Apis/WorkflowsApi";
import SignalRService from "../../one-query/services/SignalRService";
import PopupForDisplayApp from "./PopupForDisplayApp";
import DeleteModal from "../../main-page/components/get-conversation/DeletePopup";
import WorkflowSelectedSuite from "./WorkflowSelectedSuite";
import WorkflowTextApps from "./WorkflowTextApps";
import WorkflowImageApps from "./WorkflowImageApps";
import TranslatorSetting from "./TextApps/TranslatorSetting";
import BackgroundRemoverSetting from "./ImageApps/BackgroundRemoverSetting";
import TextExtractionSetting from "./ImageApps/TextExtractionSetting";
import ImageRestoreSetting from "./ImageApps/ImageRestoreSetting";
import IllustrationGeneratorSetting from "./ImageApps/IllustrationGeneratorSetting";
import IconGeneratorSetting from "./ImageApps/IconGeneratorSetting";
import LogoGeneratorSetting from "./ImageApps/LogoGeneratorSetting";
import TextToImageSetting from "./ImageApps/TextToImageSetting";
import PromptGeneratorSetting from "./TextApps/PromptGeneratorSetting";
import ParaphraserSetting from "./TextApps/ParaphraserSetting";
import SummarizerSetting from "./TextApps/SummarizerSetting";
import HumanizerSetting from "./TextApps/HumanizerSetting";
import WorkflowVideoApps from "./WorkflowVideoApps";
import TextToVideoSetting from "./VideoApps/TextToVideoSetting";
import ImageToVideoSetting from "./VideoApps/ImageToVideoSetting";
import { selectedSettingType, SettingItemObjType, videoModelType, VideoSettings, VideoSuiteApps, VideoSuiteType } from "../../../Types/VideoSuite-Types";
import { useGetVideoSuiteAppSettings } from "../../../store/Apis/SuitesApps/VideoSuiteApi";
import { Description } from "@mui/icons-material";

interface WorkflowBodyProps {
  workflowName: string;
  isNewStep: boolean;
  workflowDetails: workflowItem[];
  selectedItemData: workflowItem;
  setIsNewStep: (flag: boolean) => void;
  setSelectedItemData: Dispatch<SetStateAction<workflowItem>>;
  setWorkflowDetails: Dispatch<SetStateAction<workflowItem[]>>;
  setWorkflowName: (name: string) => void;
}

const WorkflowBody = ({
  workflowName,
  isNewStep,
  setIsNewStep,
  workflowDetails,
  setSelectedItemData,
  setWorkflowDetails,
  selectedItemData,
  setWorkflowName,
}: WorkflowBodyProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const responsiveSize = useMediaQuery("(max-width: 700px)");
  const [isChoosingItem, setIsChoosingItem] = useState<{
    isOpen: boolean;
    isReplacing: boolean;
  }>({ isOpen: false, isReplacing: false });
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const allWorkflowData = useAppSelector((s) => s.workflows.allWorkflows);
  const allTextSuitesApps = useAppSelector((s) => s.workflows.textSuitesApps);
  const WorkflowImageAppSetting = useAppSelector(
    (s) => s.workflows.WorkflowImageAppSetting
  );
  const { workflowId } = useParams<{ workflowId: string }>();
  const UpdateWorkflowData = allWorkflowData?.find(
    (workflow) => workflow?.id === workflowId
  );
  const [selectedSuiteType, setSelectedSuiteType] = useState<number>();
  const [currentSelectedAppData, setCurrentSelectedAppData] = useState<
    SuitesAppTypes[]
  >([]);
  
  const {data:workflowsData}=useGetAllWorkFlows();
  const { CreateWorkflow, status: CreateWorkflowStatus } = useCreateWorkflow();
  const UpdateWorkflow = useupadteWorkflow();
  const isDarkMode = useAppSelector((s) => s.User.darkMode);
  const [appsVisibility, setAppsVisibility] = useState<AppsVisibilityType>({
    Translator: false,
    Humanizer: false,
    Summarizer: false,
    Paraphraser: false,
    "Prompt Generator": false,
    "Text to Image": false,
    "Logo Generator": false,
    "Icon Generator": false,
    "Illustration Generator": false,
    "Image Restore": false,
    "Text Extractor": false,
    "Background Remover": false,
    "Text to Video":false,
    "Image to Video":false
  });
  const [activeAppId,setActiveAppId]=useState<string>("")
  const { data: videoSuiteAppSettings } = useGetVideoSuiteAppSettings(activeAppId);

  useEffect(() => {
      if(workflowsData) dispatch(setAllWorkflows(workflowsData))
  }, [workflowsData]);

  const workflowNameStore = useAppSelector((s) => s.workflows.workflowName);
  const FilterApps =
    selectedSuiteType === 1
      ? currentSelectedAppData.filter(
          (app) =>
            app.suiteType === selectedSuiteType &&
            app.appType !== TextSuiteApps.TitleGenerator &&
            app.appType !== TextSuiteApps.AiDetector
        )
      : currentSelectedAppData.filter(
          (app) => app.suiteType === selectedSuiteType
        );

  const [tempStep, setTempStep] = useState<workflowItem>({
    appId: "",
    appType: "",
    selectedFromDropdownItem: "",
    inputType: "",
    outputType: "",
    selectedToDropdownItem: "",
    sliderValue: 1,
    appOrder: 0,
    suiteType: 1,
    videoSettings: {
      selectedSize: "",
      selectedModel: {
        name: "",
        version: "",
      },
      selectedMode: "",
      selectedDuration: "",
      selectedStyle: { description: "" },
      seed: null,
      generateTime: "",
      creditsNeeded: 0,
    },
  });
  useEffect(() => {
    if (workflowNameStore) setWorkflowName(workflowNameStore);
  }, [workflowNameStore]);
 useEffect(()=>{
  dispatch(setVideoAppSettings(videoSuiteAppSettings))
 },[videoSuiteAppSettings])
  useEffect(() => {
    if (UpdateWorkflowData?.id) {
      setIsNewStep(true);
      setWorkflowName(UpdateWorkflowData?.name);

      const updatedApps = UpdateWorkflowData.apps?.map((app) => {
        const modelModel=WorkflowImageAppSetting?.imageModels?.find(model=>model.modelVersion===app?.data?.modelName)?.modelName
        switch (app.appType) {
          case TextSuiteApps.Translator:
            return {
              ...app,
              selectedFromDropdownItem: app?.data?.sourceLanguage,
              selectedToDropdownItem: app?.data?.targetLanguage,
            };
          case TextSuiteApps.Humanizer:
            return {
              ...app,
              selectedFromDropdownItem: app?.data?.style,
            };
          case TextSuiteApps.Paraphraser:
            return {
              ...app,
              selectedFromDropdownItem: app?.data?.mode,
            };
          case TextSuiteApps.Summarizer:
            if (app.data?.textLength !== undefined) {
              return {
                ...app,
                selectedFromDropdownItem: app?.data?.mode,
                sliderValue: getEnumIndex(app.data.textLength),
              };
            }
            return { ...app, selectedFromDropdownItem: app?.data?.mode };
          case ImageSuiteApps.TextToImage:
            return {
              ...app,
              selectedFromDropdownItem: modelModel,
              selectedToDropdownItem: app?.data?.imageRatio,
            };
          case ImageSuiteApps.LogoGenerator:
            return {
              ...app,
              selectedFromDropdownItem: modelModel,
              selectedToDropdownItem: app?.data?.imageRatio,
            };
          case ImageSuiteApps.IconGenerator:
            return {
              ...app,
              selectedFromDropdownItem: modelModel,
              selectedToDropdownItem: app?.data?.imageRatio,
            };
          case ImageSuiteApps.IllustrationGenerator:
            return {
              ...app,
              selectedFromDropdownItem: modelModel,
              selectedToDropdownItem: app?.data?.imageRatio,
            };
          case VideoSuiteApps.TextToVideo:
            return {
              ...app,
              id: app?.appId,
              videoSettings: {
                selectedSize: app?.data.ratio,
                selectedModel: { name: app?.data.model, version: app?.data.version },
                selectedMode: app?.data?.resolution,
                selectedDuration: app?.data?.duration,
                selectedStyle: { description: app?.data?.styleName, value: app?.data?.style },
                seed: app?.data?.seed ?? 0,
                generateTime: app?.data?.generateTime ?? 0,
                creditsNeeded: app?.data?.creditsNeeded ?? 0,
              }
            };
          case VideoSuiteApps.ImageToVideo:
            return {
              ...app,
              id: app?.appId,
              videoSettings: {
                selectedSize: app?.data.ratio,
                selectedModel: { name: app?.data.model, version: app?.data.version },
                selectedMode: app?.data?.resolution,
                selectedDuration: app?.data?.duration,
                selectedStyle: { description: app?.data?.styleName, value: app?.data?.style },
                seed: app?.data?.seed ?? 0,
                generateTime: app?.data?.generateTime ?? 0,
                creditsNeeded: app?.data?.creditsNeeded ?? 0,
              },
              userInput: app?.data?.userInput,
              userInputText: app?.data?.userInputText,
            };
          default:
            return app;
        }
      });

      setWorkflowDetails(updatedApps || []);
    }
  }, [UpdateWorkflowData]);

  const handleSelectSuiteApp = (
    suiteType: number,
    appData: SuitesAppTypes[]
  ) => {
    setSelectedSuiteType(suiteType);
    setCurrentSelectedAppData(appData);
  };

  const getEnumIndex = (value: number): number => {
    const values = Object.values(SummarizeOutputValues).filter(
      (v) => typeof v === "number"
    ) as number[];
    return values.indexOf(value);
  };

  const handleChangeAppVisibilty = (
    name: keyof AppsVisibilityType,
    value: boolean
  ) => {
    setAppsVisibility((prev) => ({ ...prev, [name]: value }));
  };

  //Return last selected app in the workflow for validate the next app.
  const returnLastSelectedApp = useMemo(() => {
    if(isChoosingItem.isOpen&&!isChoosingItem.isReplacing&&selectedItemData.appId)
      return workflowDetails[selectedItemData.appOrder-2]
    if (selectedItemData.appType) {
      return selectedItemData;
    }
    return workflowDetails[workflowDetails.length - 1] || null;
  }, [workflowDetails,isChoosingItem]);
  const handleUpdateAppsVisibity=(appType:string)=>{
    if (appType) {
      const newVisibility: AppsVisibilityType = { ...appsVisibility };

      for (const key in newVisibility) {
        newVisibility[key as keyof AppsVisibilityType] = key === appType;
      }

      setAppsVisibility(newVisibility);
    }
  }
  useEffect(() => {
    handleUpdateAppsVisibity(selectedItemData.appType);
  }, [selectedItemData]);
  
  //   update workflow
 const handleSaveChangeWorkflow = async () => {
  if (workflowName.trim().length === 0) {
    dispatch(
      setFileError({
        isError: true,
        errorMsg: "Cannot save: Workflow name is required.",
        reason: "user upload file type not support",
      })
    );
    return;
  } else if (workflowDetails.length === 0) {
     dispatch(
      setFileError({
        isError: true,
        errorMsg: "Cannot save: workflow has no apps.",
        reason: "user upload file type not support",
      })
    );
    return;
  }

  const formData = new FormData();
  formData.append("id", UpdateWorkflowData?.id || "");
  formData.append("name", workflowName);

  workflowDetails.forEach((item, index) => {
    const matchedApp = allTextSuitesApps.find(
      (app) => app.appType === item.appType
    );
    if (matchedApp) {
      formData.append(`apps[${index}].appId`, matchedApp.id.toUpperCase());
      formData.append(`apps[${index}].payload`, getAppDetails(item,WorkflowImageAppSetting));
      formData.append(`apps[${index}].appOrder`, (index + 1).toString());

      if (
        item.userInput &&
        item.suiteType === WorkflowAppType.VideoSuite&&
        item?.userInput instanceof File
      ) {
        formData.append(`apps[${index}].userInput`, item.userInput as File);
      }
    }
  });

  UpdateWorkflow(formData);
};

  const handleSetActiveItem = (app: SuitesAppTypes): void => {
    if (app.appType !== selectedItemData.appType) {
      if(app.suiteType===WorkflowAppType.VideoSuite)
           setActiveAppId(app?.id ?? "");
      handleUpdateAppsVisibity(app.appType);
      if (isNewStep)
        setTempStep((prev) => ({
          ...prev,
          appId:app.id,
          appType: app.appType,
          selectedFromDropdownItem: "",
          selectedToDropdownItem: "",
          sliderValue: 1,
          appOrder: workflowDetails.length + 1,
          suiteType: app.suiteType,
          inputType: app.inputType,
          outputType: app.outputType,
        }));
      else {
        if (workflowDetails.length === 0)
          setTempStep((prev) => ({
            ...prev,
            appId:app.id,
            appType: app.appType,
            selectedFromDropdownItem: "",
            selectedToDropdownItem: "",
            sliderValue: 1,
            appOrder: 1,
            suiteType: app.suiteType,
            inputType: app.inputType,
            outputType: app.outputType,
          }));
        else {
          workflowDetails.pop();
          setTempStep((prev) => ({
            ...prev,
            appId:app.id,
            appType: app.appType,
            selectedFromDropdownItem: "",
            selectedToDropdownItem: "",
            sliderValue: 1,
            appOrder: workflowDetails.length + 1,
            suiteType: app.suiteType,
            inputType: app.inputType,
            outputType: app.outputType,
          }));
        }
      }
    }
    setIsChoosingItem((prev) => ({
      ...prev,
      isOpen: true,
      isReplacing: false,
    }));
  };

  const handleCancelWorkflow = () => {
    navigate("/workflows");
  };

 const handleCreateWorkflow = async () => {
  const connectionId = await SignalRService.getInstance().getConnectionId();

  const formData = new FormData();
  formData.append("name", workflowName);
  formData.append("connectionId", connectionId);

  workflowDetails.forEach((item, index) => {
    const matchedApp = allTextSuitesApps.find(
      (app) => app.appType === item.appType
    );
    if (matchedApp) {
      formData.append(`apps[${index}].appId`, matchedApp.id.toUpperCase());
      formData.append(`apps[${index}].payload`, getAppDetails(item,WorkflowImageAppSetting));
      formData.append(`apps[${index}].appOrder`, (index + 1).toString());
      if(item.userInput&& item.suiteType===WorkflowAppType.VideoSuite)
         formData.append(`apps[${index}].userInput`, item.userInput as File);
    }
  });

  if (workflowName.trim().length === 0) {
    dispatch(
      setFileError({
        isError: true,
        errorMsg: "Cannot save: Workflow name is required.",
        reason: "user upload file type not support",
      })
    );
  } else {
    CreateWorkflow(formData); 
  }
};

  const handleCancelPopUp = () => {
    setIsChoosingItem({ isOpen: false, isReplacing: false });
    handleChangeAppVisibilty(
      tempStep.appType as keyof AppsVisibilityType,
      false
    );
      handleChangeAppVisibilty(
      selectedItemData.appType as keyof AppsVisibilityType,
      true
    );
  };
  const handleChooseAppDetails = () => {
    setIsChoosingItem((prev) => ({ ...prev, isReplacing: false }));
  };
  const handleAddNewStep = (data: workflowItem) => {
    setSelectedItemData({ ...data });
    handleChangeAppVisibilty(
      tempStep.appType as keyof AppsVisibilityType,
      false
    );
    setWorkflowDetails((prev) => {
      const index = prev.findIndex((item) => item.appOrder === data.appOrder);
      if (index !== -1) {
        // Replace existing object
        const updatedWorkflow = [...prev];
        updatedWorkflow[index] = data;
        return updatedWorkflow;
      } else {
        // Append new object
        return [...prev, data];
      }
    });
    setIsNewStep(true);
    setSelectedItemData({
      appType: "",
      selectedFromDropdownItem: "",
      selectedToDropdownItem: "",
      appOrder: 0,
      sliderValue: 1,
      suiteType: 1,
      inputType: "",
      outputType: "",
      videoSettings: {
        selectedSize: "",
        selectedModel: {
          name: "",
          version: "",
        },
        selectedMode: "",
        selectedDuration: "",
        selectedStyle: { description: "" },
        seed: null,
        generateTime: "",
        creditsNeeded:0
      },
    });
    setTempStep({
      appId: "",
      appType: "",
      selectedFromDropdownItem: "",
      selectedToDropdownItem: "",
      appOrder: 0,
      sliderValue: 1,
      suiteType: 1,
      inputType: "",
      outputType: "",
      videoSettings: {
        selectedSize: "",
        selectedModel: {
          name: "",
          version: "",
        },
        selectedMode: "",
        selectedDuration: "",
        selectedStyle: { description: "" },
        seed: null,
        generateTime: "",
        creditsNeeded:0
      },
    });
  };

  const handleCheckIsValidateDelete = (appOrder: number) => {
    const workflowSteps = workflowDetails.filter(
      (step) => step.appOrder !== appOrder
    );

    if (workflowSteps.length <= 1) {
      return true;
    }

    for (let i = 0; i < workflowSteps.length - 1; i++) {
      if (workflowSteps[i].outputType !== workflowSteps[i + 1].inputType) {
        return false;
      }
    }

    return true;
  };

  const handleDeleteStep = (index: number) => {
    const isDeleteValid = handleCheckIsValidateDelete(index + 1);
    if (isDeleteValid) {
      setWorkflowDetails((prev) => {
        const newWorkflow = prev.filter((_, i: number) => i !== index);

        // Reassign appOrder starting from 1
        const updatedWorkflow = newWorkflow.map((step, i: number) => ({
          ...step,
          appOrder: i + 1, // Ensure sequential numbering starting from 1
        }));

        // Update selectedItemData if the deleted step was selected
        setSelectedItemData((prevSelected:any) => {
          if (prevSelected && prevSelected.appOrder === prev[index]?.appOrder) {
            return {
              appType: "",
              selectedFromDropdownItem: "",
              selectedToDropdownItem: "",
              appOrder: 0,
              sliderValue: 0,
              suiteType: 1,
              inputType: "",
              outputType: "",
              videoSettings: {
                selectedSize: "",
                selectedModel: {
                  name: "",
                  version: "",
                },
                selectedMode: "",
                selectedDuration: "",
                selectedStyle: { description: "" },
                seed: null,
                generateTime: "",
              },
            }; // Clear selection if deleted
          }
          return prevSelected;
        });

        return updatedWorkflow;
      });
      setSelectedItemData({
        appType: "",
        selectedFromDropdownItem: "",
        selectedToDropdownItem: "",
        appOrder: 0,
        sliderValue: 1,
        suiteType: 1,
        inputType: "",
        videoSettings:{
        selectedSize: "",
        selectedModel: {
          name: "",
          version: ""
        },
        selectedMode: "",
        selectedDuration: "",
        selectedStyle: {description:""},
        seed: null,
        generateTime: "",
        creditsNeeded: 0
      }
      });
      setIsNewStep(true);
      setShowDelete(false);
    } else {
      setShowDelete(false);
      dispatch(
        setSnackBarAlert({
          show: true,
          message:
            "This step can't be deleted because other steps rely on its result.To delete it, please remove the connected steps first.",
          alertType: "error",
        })
      );
    }
  };
const handleModelSettingChanges = (
  activeAppId:string,
  name:string,
  value: number | string | SettingItemObjType | videoModelType
) => {
  if(activeAppId===selectedItemData.appId)
     setSelectedItemData((prev:any) => ({
    ...prev,
    videoSettings: {
      ...prev.videoSettings,
      [name]: value,
    },
  }));
  else if(activeAppId===tempStep.appId)
   setTempStep((prev:any) => ({
    ...prev,
    videoSettings: {
      ...prev.videoSettings,
      [name]: value,
    },
  }));
};
  const handleUserInputImageChange = (activeAppId:string,input: File | string | null) => {
    if(activeAppId===selectedItemData.appId)
      setSelectedItemData((prev) => ({
      ...prev,
      userInput: input
    }));
  else if(activeAppId===tempStep.appId)
    setTempStep((prev) => ({
      ...prev,
      userInput:input    
    }));

  };
  const handleUserInputTextChange = (activeAppId:string,input:string | null) => {
    if(activeAppId===selectedItemData.appId)
      setSelectedItemData((prev) => ({
      ...prev,
      userInputText: input
    }));
  else if(activeAppId===tempStep.appId)
    setTempStep((prev) => ({
      ...prev,
      userInputText:input    
    }));

  };

  const isFirstStep=useMemo(()=>{
    if (!selectedItemData || !selectedItemData.appOrder) return false;
    const index= workflowDetails.findIndex(
      (item) => item.appOrder === selectedItemData.appOrder
    );

    return index=== 0 ? true : false;
  },[selectedItemData?.appOrder,workflowDetails])

    const isFirstStepForEdit = useMemo(() => {
      if(tempStep.appType)
        return tempStep?.appOrder-1=== 0? true : false;
      else
      return selectedItemData?.appOrder-1=== 0? true : false;
    
    }, [selectedItemData?.appOrder,tempStep?.appOrder,workflowDetails]);

  return (
    <>
      <Box className="Choose-apps position-relative">
        <Box className="workflow-apps-preview">
          {selectedItemData.appType ? (
            <>
              <div className="mt-3 mb-3">
                {GetAppType(selectedItemData.appType)} suite
              </div>
              <div
                className={`display-app ${
                  selectedItemData.appType.length > 0 && "preview"
                }`}
              >
                {!isChoosingItem.isOpen && (
                  <>
                    <div
                      className={`displaySettingAppReadOnly`}
                      style={{
                        boxShadow: isDarkMode
                          ? "0px 0px 20px 0px #0000002e"
                          : "none",
                      }}
                    >
                      {appsVisibility.Translator && (
                        <TranslatorSetting
                          isFirstStep={
                            isFirstStep
                          }
                          selectedFromDropdownItem={
                            selectedItemData?.selectedFromDropdownItem || ""
                          }
                          selectedToDropdownItem={
                            selectedItemData?.selectedToDropdownItem || ""
                          }
                          readOnly={true}
                          canShow={appsVisibility.Translator}
                        />
                      )}
                      {appsVisibility.Humanizer && (
                        <HumanizerSetting
                          isFirstStep={
                            isFirstStep
                          }
                          selectedFromDropdownItem={
                            selectedItemData?.selectedFromDropdownItem || ""
                          }
                          readOnly={true}
                          canShow={appsVisibility.Humanizer}
                        />
                      )}
                      {appsVisibility.Summarizer && (
                        <SummarizerSetting
                          isFirstStep={
                            isFirstStep
                          }
                          sliderValue={selectedItemData?.sliderValue || 1}
                          selectedFromDropdownItem={
                            selectedItemData?.selectedFromDropdownItem || ""
                          }
                          readOnly={true}
                          canShow={appsVisibility.Summarizer}
                        />
                      )}
                      {appsVisibility.Paraphraser && (
                        <ParaphraserSetting
                          isFirstStep={
                            isFirstStep
                          }
                          selectedFromDropdownItem={
                            selectedItemData?.selectedFromDropdownItem || ""
                          }
                          readOnly={true}
                          canShow={appsVisibility.Paraphraser}
                        />
                      )}
                      {appsVisibility["Prompt Generator"] && (
                        <PromptGeneratorSetting
                          isFirstStep={
                            isFirstStep
                          }
                          readOnly={true}
                          canShow={appsVisibility["Prompt Generator"]}
                        />
                      )}
                      {appsVisibility["Text to Image"] && (
                        <TextToImageSetting
                          isFirstStep={
                            isFirstStep
                          }
                          selectedFromDropdownItem={
                            selectedItemData?.selectedFromDropdownItem || ""
                          }
                          selectedToDropdownItem={
                            selectedItemData?.selectedToDropdownItem || ""
                          }
                          readOnly={true}
                          canShow={appsVisibility["Text to Image"]}
                        />
                      )}
                      {appsVisibility["Logo Generator"] && (
                        <LogoGeneratorSetting
                          isFirstStep={
                            isFirstStep
                          }
                          selectedFromDropdownItem={
                            selectedItemData?.selectedFromDropdownItem || ""
                          }
                          selectedToDropdownItem={
                            selectedItemData?.selectedToDropdownItem || ""
                          }
                          readOnly={true}
                          canShow={appsVisibility["Logo Generator"]}
                        />
                      )}
                      {appsVisibility["Icon Generator"] && (
                        <IconGeneratorSetting
                          isFirstStep={
                            isFirstStep
                          }
                          selectedFromDropdownItem={
                            selectedItemData?.selectedFromDropdownItem || ""
                          }
                          selectedToDropdownItem={
                            selectedItemData?.selectedToDropdownItem || ""
                          }
                          readOnly={true}
                          canShow={appsVisibility["Icon Generator"]}
                        />
                      )}
                      {appsVisibility["Illustration Generator"] && (
                        <IllustrationGeneratorSetting
                          isFirstStep={
                            isFirstStep
                          }
                          selectedFromDropdownItem={
                            selectedItemData?.selectedFromDropdownItem || ""
                          }
                          selectedToDropdownItem={
                            selectedItemData?.selectedToDropdownItem || ""
                          }
                          readOnly={true}
                          canShow={appsVisibility["Illustration Generator"]}
                        />
                      )}
                      {appsVisibility["Image Restore"] && (
                        <ImageRestoreSetting
                          isFirstStep={
                            isFirstStep
                          }
                          readOnly={true}
                          canShow={appsVisibility["Image Restore"]}
                        />
                      )}
                      {appsVisibility["Text Extractor"] && (
                        <TextExtractionSetting
                          isFirstStep={
                            isFirstStep
                          }
                          readOnly={true}
                          canShow={appsVisibility["Text Extractor"]}
                        />
                      )}
                      {appsVisibility["Background Remover"] && (
                        <BackgroundRemoverSetting
                          isFirstStep={
                            isFirstStep
                          }
                          readOnly={true}
                          canShow={appsVisibility["Background Remover"]}
                        />
                      )}
                      {appsVisibility["Text to Video"] && (
                        <TextToVideoSetting
                          currentStep={selectedItemData}
                          videoSettings={selectedItemData?.videoSettings}
                          readOnly={true}
                          handleModelSettingChanges={handleModelSettingChanges}
                          canShow={appsVisibility["Text to Video"]}
                          isFirstStep={
                            isFirstStep
                          }
                        />
                      )}
                      {appsVisibility["Image to Video"] && (
                        <ImageToVideoSetting
                          currentStep={selectedItemData}
                          videoSettings={selectedItemData?.videoSettings}
                          readOnly={true}
                          outputTypeOfLastApp={
                            returnLastSelectedApp?.outputType
                          }
                          handleModelSettingChanges={handleModelSettingChanges}
                          handleUserInputImageChange={
                            handleUserInputImageChange
                          }
                          handleUserInputTextChange={handleUserInputTextChange}
                          canShow={appsVisibility["Image to Video"]}
                          isFirstStep={
                            isFirstStep
                          }
                        />
                      )}
                    </div>
                    <div className="settings-workflows">
                      <Box
                        className={`settings-icons workflow`}
                        sx={{ marginTop: "0rem" }}
                        onClick={() =>
                          setIsChoosingItem({
                            isOpen: true,
                            isReplacing: false,
                          })
                        }
                      >
                        <MuiTooltip
                          title="Edit"
                          placement="right"
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "var(--A_background73)",
                                color: "var(--A_font-color48)",
                                padding: "0.3rem 0.8rem",
                              },
                            },
                          }}
                          disableHoverListener={responsiveSize}
                          disableFocusListener={responsiveSize}
                        >
                          <IconButton>
                            <EditPinWithBackgroundIcon className="custom-icon" />
                          </IconButton>
                        </MuiTooltip>
                      </Box>
                      <Box
                        className={`settings-icons workflow`}
                        onClick={() =>
                          setIsChoosingItem({
                            isOpen: true,
                            isReplacing: true,
                          })
                        }
                      >
                        <MuiTooltip
                          title="Replace"
                          placement="right"
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "var(--A_background73)",
                                color: "var(--A_font-color48)",
                                padding: "0.3rem 0.8rem",
                              },
                            },
                          }}
                          disableHoverListener={responsiveSize}
                          disableFocusListener={responsiveSize}
                        >
                          <IconButton>
                            <ReplaceIcon className="custom-icon" />
                          </IconButton>
                        </MuiTooltip>
                      </Box>
                      <Box
                        className={`settings-icons workflow`}
                        onClick={() => setShowDelete(true)}
                      >
                        <MuiTooltip
                          title="Delete"
                          placement="right"
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "var(--A_background73)",
                                color: "var(--A_font-color48)",
                                padding: "0.3rem 0.8rem",
                              },
                            },
                          }}
                          disableHoverListener={responsiveSize}
                          disableFocusListener={responsiveSize}
                        >
                          <IconButton>
                            <DeleteIcon className="custom-icon" />
                          </IconButton>
                        </MuiTooltip>
                      </Box>
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <WorkflowSelectedSuite
                handleSelectSuiteApp={handleSelectSuiteApp}
                setSelectedSuiteType={setSelectedSuiteType}
                selectedSuiteType={selectedSuiteType || 1}
              />
              {FilterApps &&
                (selectedSuiteType === 1 ? (
                  <WorkflowTextApps
                    apps={FilterApps}
                    selectedItemData={selectedItemData}
                    returnLastSelectedApp={returnLastSelectedApp}
                    handleSetActiveItem={handleSetActiveItem}
                    selectedSuiteType={selectedSuiteType}
                  />
                ) : selectedSuiteType === 2 ? (
                  <WorkflowImageApps
                    apps={FilterApps}
                    selectedItemData={selectedItemData}
                    returnLastSelectedApp={returnLastSelectedApp}
                    handleSetActiveItem={handleSetActiveItem}
                  />
                ) : selectedSuiteType === 3 ? (
                  <WorkflowVideoApps
                    apps={FilterApps}
                    selectedItemData={selectedItemData}
                    returnLastSelectedApp={returnLastSelectedApp}
                    handleSetActiveItem={handleSetActiveItem}
                  />
                ) : null)}
            </>
          )}
        </Box>
        <span className="w-100 container-btns ">
          {UpdateWorkflowData && UpdateWorkflowData?.id?.length > 0 ? (
            <div className="apply-buttons btns-create-workflow">
              <button
                className="CancelDeletePersonaBtn"
                onClick={handleCancelWorkflow}
              >
                Discard
              </button>
              <button
                className="createPersonaBtn"
                onClick={handleSaveChangeWorkflow}
              >
                Save changes
              </button>
            </div>
          ) : (
            <div className="apply-buttons btns-create-workflow">
              <button
                className="CancelDeletePersonaBtn"
                onClick={handleCancelWorkflow}
              >
                Cancel
              </button>
              <button
                className={`createPersonaBtn ${
                  CreateWorkflowStatus === "pending" ||
                  workflowDetails.length === 0
                    ? "opacity-50"
                    : ""
                }`}
                onClick={handleCreateWorkflow}
                disabled={
                  CreateWorkflowStatus === "pending" ||
                  workflowDetails.length === 0
                }
              >
                Save workflow
              </button>
            </div>
          )}
        </span>
      </Box>
      {isChoosingItem && (
        <PopupForDisplayApp
          show={isChoosingItem.isOpen}
          handleClose={handleCancelPopUp}
          setTempStep={setTempStep}
          currentStep={
            tempStep.appType.length > 0 ? tempStep : selectedItemData
          }
          isFirstStep={isFirstStepForEdit}
          appsVisibility={appsVisibility}
          tempStep={tempStep}
          AddNewStep={handleAddNewStep}
          workflowDetails={workflowDetails}
          isReplacing={isChoosingItem.isReplacing}
          handleChooseAppDetails={handleChooseAppDetails}
          currentSelectedWorkflowData={workflowDetails}
          handleModelSettingChanges={handleModelSettingChanges}
          outputTypeOfLastApp={returnLastSelectedApp?.outputType || ""}
          handleUserInputImageChange={handleUserInputImageChange}
          handleUserInputTextChange={handleUserInputTextChange}
          handleUpdateAppsVisibity={handleUpdateAppsVisibity}
        />
      )}
      {showDelete && (
        <DeleteModal
          show={showDelete}
          handleClose={() => setShowDelete(false)}
          method={() => handleDeleteStep(selectedItemData.appOrder - 1)}
          name="Delete step"
          message={`Are you sure to delete "${selectedItemData?.appType}" step?`}
          deleteStep={true}
        />
      )}
    </>
  );
};

export default WorkflowBody;
